import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import StatusSelect from './StatusSelect';
import {
  dueLabel, dueTone, formatDate, railTone,
} from './lib/dates';

// One row of the list. The columns after the title line up with ListHeader,
// so a width change here needs the same change there (they share the classes).
export default function TaskCard({
  task, today, open, dragging, dragHandleProps, innerRef, draggableProps, onOpen, onStatus,
}) {
  const tone = dueTone(task, today);
  const comments = (task.comments || []).length;
  return (
    <div
      ref={innerRef}
      {...draggableProps}
      className={s.row}
      data-rail={railTone(task, today)}
      data-open={open ? 'true' : undefined}
      data-dragging={dragging ? 'true' : undefined}
      onClick={() => onOpen(task)}
      onKeyDown={(e) => { if (e.key === 'Enter' && e.target === e.currentTarget) onOpen(task); }}
      role="button"
      tabIndex={0}
      aria-label={`Open ${task.title}`}
    >
      <span className={s.grip} {...dragHandleProps} aria-label="Drag to reorder" title="Drag to reorder">⋮⋮</span>
      <div className={s.rowMain}>
        <p className={s.rowTitle}>{task.title}</p>
        {(task.assignee_name || comments > 0) && (
          <div className={s.meta}>
            {task.assignee_name && <span>{task.assignee_name}</span>}
            {comments > 0 && (
              <span>
                {comments}
                {' '}
                comment
                {comments === 1 ? '' : 's'}
              </span>
            )}
          </div>
        )}
      </div>
      <span className={s.colCreated} title={task.created_at ? `Created ${formatDate(task.created_at)}` : undefined}>
        {formatDate(task.created_at)}
      </span>
      <span className={s.colPriority}>
        {task.priority === 'high' && <span className={s.pillHigh}>High</span>}
        {task.priority === 'low' && <span className={s.pill}>Low</span>}
      </span>
      <span className={`${s.colDue} ${tone ? s[`due-${tone}`] : ''}`}>
        {dueLabel(task, today)}
      </span>
      <StatusSelect
        className={s.colStatus}
        value={task.status}
        label={`Status of ${task.title}`}
        onChange={(status) => onStatus(task, status)}
      />
    </div>
  );
}

TaskCard.propTypes = {
  task: taskShape.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  open: PropTypes.bool,
  dragging: PropTypes.bool,
  dragHandleProps: PropTypes.objectOf(PropTypes.any),
  draggableProps: PropTypes.objectOf(PropTypes.any),
  innerRef: PropTypes.func,
  onOpen: PropTypes.func.isRequired,
  onStatus: PropTypes.func.isRequired,
};
TaskCard.defaultProps = {
  open: false, dragging: false, dragHandleProps: undefined, draggableProps: undefined, innerRef: undefined,
};
